import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { Form, Input, Checkbox, Button, Divider } from 'antd';

import { ReactComponent as PasswordHide } from '@/views/account/assets/icons/password-hidden.svg';
import { ReactComponent as PasswordShow } from '@/views/account/assets/icons/password-show.svg';
import { ReactComponent as GoogleIcon } from '@/views/account/assets/icons/google.svg';
import Validator from '@/views/account/utils/formValidator';
import {
  GALoginClickToSignUp,
  GALoginClickConfirm,
  GALoginClickToService,
  GALoginClickToPrivacy,
} from '@/views/account/ga/login';
import { GAForgotPasswordBtnClick } from '@/views/account/ga/forgotPassword';
import '@/views/account/assets/login.scss';
import { getGoogleUrl } from '@/views/account/api/apis';
import Cookies from 'js-cookie';
import sentGAEvent from '@/views/account/ga';
import Utils from '@/utils/utils';
import './render.less';
import HitPawLogo from '@/views/account/assets/images/hitpaw-logo.png';
const LoginRender = ({
  handleForgotPasswordModalVisible,
  loginLoading,
  handleRequestLogin,
  urlSearch,
}) => {
  const { t } = useTranslation(['loginAndSignUp', 'common']);

  const [googleLoading, setGoogleLoading] = useState(false);
  const [showGoogle, setShowGoogle] = useState(true);
  const tailLayout = {
    wrapperCol: { offset: 0, span: 32 },
  };
  const loginByGoogle = () => {
    sentGAEvent({
      category: 'login',
      action: 'GoogleLogin_Click',
    });
    const urlParams = new URLSearchParams(urlSearch);
    const sliceIndex = window.location.href.lastIndexOf('#') + 1;
    let personalUrl;
    const localUrl = urlParams.get('redirect');
    const to = urlParams.get('to');
    // 这里用于兼容不是从功能页跳转登录的情况，即从购买页登录，没有redirect，只有to
    // 如果没有redirect，有to，说明是购买跳的登录，登录完重回购买
    if (!localUrl && to) {
      personalUrl = window.location.href.substring(0, sliceIndex) + '/purchase';
      localStorage.setItem('redirect', personalUrl);
    } else {
      // personalUrl =
      //   window.location.href.substring(0, sliceIndex) +
      //   '/personal-center/profile';
      if (localUrl) {
        localStorage.setItem('redirect', localUrl);
      }
    }
    // localStorage.setItem('localUrl', localUrl); //重定向地址
    // localStorage.setItem('personalUrl', personalUrl); //个人中心地址
    let url = window.location.href.split('?')[0];
    window.location.href = url;
    setGoogleLoading(window.location.href);
    getGoogleUrl(window.location.href)
      .then((res) => {
        setGoogleLoading(false);
        console.log('res', res);
        if (res.code === 200) {
          window.location.href = res.data.redirect;
        }
      })
      .catch((err) => {
        setGoogleLoading(false);
      });
  };
  /**
   * 自定义密码显示和隐藏icon
   * @param {*} visible
   */
  const passWordIconRender = (visible) =>
    visible ? <PasswordShow /> : <PasswordHide />;

  const [form] = Form.useForm();

  // 是否展示google登录
  const isShowGoogle = () => {
    let nonGoogle = ['kr', 'ar', 'nl', 'tr', 'tw']; // 因google重定向地址配置问题，暂不展示第三方登录
    const curLang = Utils.getLanguage();
    const showGoogle = !nonGoogle.includes(curLang);
    setShowGoogle(showGoogle);
  };

  // 进入登录页面的时候检查链接是否有带urlSearch
  // 1、带了 urlSearch，说明是从其他站点的功能页面跳转过来登录，走正常逻辑
  // 2、没带 urlSearch，则是从购买页进入，点击购买按钮才跳的登录，这时候重新获取urlSearch
  const redirectToPurchase = () => {
    let href = window.location.href;
    if (urlSearch === '') {
      urlSearch =
        href.indexOf('?') !== -1 ? href.substring(href.indexOf('?')) : '';
    }
  };

  redirectToPurchase();

  useEffect(() => {
    isShowGoogle();
  }, []);
  const linkToOnline = () => {
    window.location.href = 'https://online.hitpaw.com/';
  };
  return (
    <div className='LoginComponent'>
      <div className='leftImg' />
      <div className='rightForm'>
        <div className='topContainer'>
          <img
            className='hitPawLogo'
            onClick={() => linkToOnline()}
            src={HitPawLogo}
          />
          <div className='loginText'>
            {t('upgradePersonal:loginYourAccount')}
          </div>
        </div>
        <div className='loginForm'>
          <Form
            form={form}
            name='loginForm'
            onFinish={handleRequestLogin}
            initialValues={{
              remember: Cookies.get('_u_info') ? true : false,
              email: Cookies.get('_u_info')
                ? JSON.parse(Cookies.get('_u_info')).e
                : '',
              password: Cookies.get('_u_info')
                ? JSON.parse(Cookies.get('_u_info')).p
                : '',
            }}
            validateTrigger='onBlur'
          >
            <Form.Item
              name='email'
              label=''
              rules={[
                {
                  required: true,
                  formName: 'login',
                  validator: Validator.emailValidator,
                },
              ]}
            >
              <Input
                className='inputArea'
                placeholder={t('common:email')}
                allowClear
              />
            </Form.Item>
            <Form.Item
              name='password'
              className='inputArea'
              label=''
              rules={[
                {
                  required: true,
                  formName: 'login',
                  validator: Validator.passwordValidator,
                },
              ]}
            >
              <Input.Password
                placeholder={t('common:password')}
                iconRender={passWordIconRender}
                allowClear
              />
            </Form.Item>
            <Form.Item
              {...tailLayout}
              name='remember'
              label=''
              valuePropName='checked'
              className='forgetPassword'
            >
              <Checkbox className='small'>{t('rememberMe')}</Checkbox>
              <span
                style={{ display: 'block', cursor: 'pointer' }}
                className='text-primary'
                onClick={() => {
                  handleForgotPasswordModalVisible(true);
                  GAForgotPasswordBtnClick('login');
                }}
              >
                {t('forgotPassword')}
              </span>
            </Form.Item>
            <Form.Item>
              <Button
                className='w-100 fw-bolder loginBtn'
                type='primary'
                htmlType='submit'
                size='large'
                loading={loginLoading}
                onClick={() => {
                  GALoginClickConfirm(
                    form.getFieldValue('remember') ? 'yes' : ''
                  );
                }}
              >
                {t('common:login')}
              </Button>
            </Form.Item>
          </Form>
          <p className='pb-4 text-center signUpText'>
            {t('signUpTips')}
            <Link
              className='ms-2'
              to={`/signUp${urlSearch}`}
              onClick={GALoginClickToSignUp}
            >
              {' '}
              {t('common:signUp')}
            </Link>
          </p>

          <Divider plain>Or</Divider>
          <Button
            onClick={() => loginByGoogle()}
            className='w-100 fw-bolder'
            icon={<GoogleIcon style={{ marginRight: 5 }} />}
            type='default'
            loading={googleLoading}
            size='large'
            style={{
              marginBottom: 16,
              borderRadius: 100,
              height: 56,
            }}
          >
            {t('ContinuewithGoogle')}
          </Button>
          <p
            className='mb-4 text-center small'
            style={{ color: 'rgba(27, 27, 27, 0.5)' }}
          >
            <Trans i18nKey='loginAndSignUp:loginPrivacyTips'>
              Text
              <Link
                className='text-primary'
                to='/services-policy'
                onClick={GALoginClickToService}
                target='_blank'
              >
                Link
              </Link>
              Text
              <Link
                className='text-primary'
                to='/privacy-policy'
                onClick={GALoginClickToPrivacy}
                target='_blank'
              >
                Link
              </Link>
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginRender;
